import { useEffect, useState } from 'react';
import { FormInitState } from '../constants/FormInitState';
import CalculateSavingsService from '../services/CalculateSavings.service';
import { SetSetpValuesProps, StepValues, ValueByStep } from '../types';

const useFormService = () => {
  const [step, setStep] = useState(0);
  const [values, setValues] = useState<StepValues>(FormInitState);
  const [savings, setSavings] = useState(0);

  const calculateSavingsService = new CalculateSavingsService();

  useEffect(() => {
    if (values.step1 && !values.step2) {
      setStep(ValueByStep.volume + 1);
    } else if (values.step2 && !values.step3) {
      setStep(ValueByStep.providers + 1);
    } else if (values.step3) {
      setStep(ValueByStep.people + 1);
    }
  }, [values]);

  const resetFormState = () => {
    setValues(FormInitState);
    setStep(0);
    setSavings(0);
  };

  const setStepValue = ({ newStep, value }: SetSetpValuesProps) => {
    setValues((prevValues) => ({
      ...prevValues,
      [`step${newStep}`]: value,
    }));
  };

  const calculateSavings = () => {
    setSavings(calculateSavingsService.calculateSavings(values));
  };

  return {
    step,
    values,
    savings,
    setStepValue,
    resetFormState,
    calculateSavings,
  };
};

export default useFormService;
